import React from 'react';
import { useSelector } from 'react-redux';

import { Attitude as AttitudeUI } from '@/components/ui/dashboard/Monitor';

const Attitude = ({ data: robotId, className }) => {
  const droneOsd = useSelector((state) => state.telemetry[robotId]?.droneOsd);

  return (
    <AttitudeUI
      roll={droneOsd?.attitude_roll ?? 0}
      pitch={droneOsd?.attitude_pitch ?? 0}
      yaw={droneOsd?.attitude_head ?? 0}
      className={className}
    />
  );
};

export default Attitude;
